import { Button } from '@/components/ui/Button';
import styles from './SessionRestorePrompt.module.css';

interface Props {
  sessionName: string;
  onContinue(): void;
  onStartFresh(): void;
}

/** Modal that gates IndexedDB session hydration. Shown on tool load when a
 *  previously-stored session with meaningful state is found. Continue
 *  applies the stored state and drops the user wherever they were;
 *  Start Fresh wipes the IndexedDB record and sends them back to Welcome. */
export function SessionRestorePrompt({
  sessionName,
  onContinue,
  onStartFresh,
}: Props) {
  const handleStartFresh = () => {
    if (
      window.confirm(
        'This will delete your local progress for this project. Continue?',
      )
    ) {
      onStartFresh();
    }
  };

  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true">
      <div className={styles.panel}>
        <h2 className={styles.title}>Session Found</h2>
        <p className={styles.body}>
          A previous session was found for <strong>{sessionName}</strong>.
          Would you like to continue or start over?
        </p>
        <div className={styles.actions}>
          <Button variant="ghost" size="sm" onClick={handleStartFresh}>
            <i className="ph-bold ph-arrow-clockwise" aria-hidden="true" />
            Start Fresh
          </Button>
          <Button variant="primary" size="sm" onClick={onContinue}>
            <i className="ph-fill ph-arrow-fat-line-right" aria-hidden="true" />
            Continue Session
          </Button>
        </div>
      </div>
    </div>
  );
}
